import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { AuditQuestionnaireComponent, AuditResponseChange } from "../../components/audit-questionnaire/audit-questionnaire.component";
import { CEMENT_JOB_QUESTIONS } from "../../data/lab-audit-questions";
import { LabAuditStateService } from "../../services/lab-audit-state.service";

@Component({
  selector: "app-cement-job-tab",
  standalone: true,
  imports: [AuditQuestionnaireComponent],
  templateUrl: "./cement-job-tab.component.html",
  styleUrl: "./cement-job-tab.component.css",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CementJobTabComponent {
  readonly auditState = inject(LabAuditStateService);
  readonly questions = CEMENT_JOB_QUESTIONS;

  updateResponse(change: AuditResponseChange): void {
    this.auditState.updateResponse("cementJob", change.questionId, change.changes);
  }
}
